import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from 'classnames';

import './button.less';

class Button extends Component {
	render() {
		let {disabled, small, href, target, text, outline, ...compProps} = this.props;

		let className = classNames(
			"nov-button",
			{
				"button-small": small,
				"button-text": text,
				"button-outline": outline
			}
		);

		let Component = 'button';

		if (href) {
			Component = 'a';
			compProps.href = href;
			compProps.target = target;
			compProps.role = 'button';	
		} else {
			compProps.type = 'button';
			compProps.disabled = disabled;			
		}
		
		return (
			<Component className={className} {...compProps} />
		);
	}
}

Button.propTypes = {
	children: PropTypes.node,
	disabled: PropTypes.bool,
	// If an href is passed in then it will render an 'a' element instead of a 'button' element
	href: PropTypes.string,
	onClick: PropTypes.func,
	// This is the target attribute for a link button
	target: PropTypes.string,
	style: PropTypes.object, 
	outline: PropTypes.string
}

export default Button;



// WEBPACK FOOTER //
// ./src/react/views/generic/Button.jsx